module.exports = __webpack_public_path__ + "assets/images/plannerTrace-a0511c67043aa02a18b4b6cd4280a65b.gif";